module.exports = __webpack_public_path__ + "static/img/show.6a79349e.png";